module.exports = __webpack_public_path__ + "static/media/main.924f60b2.jpeg";